import React, { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay";
import axios from "../../../axios/axios";
import { message } from "antd";
import DataTable from "react-data-table-component";
import { Row, Col, Form } from "react-bootstrap";
import ReactSelect from "react-select";
import { adminConfig } from "../../../utils/adminConfig";

export default function LimitCertificate() {
  const [loading, setLoading] = useState(false);
  const [optionUser, setoptionUser] = useState([]);
  const [selected, setSelected] = useState([]);
  const [limitList, setLimitList] = useState([]);
  const [submitData, setSubmitData] = useState({
    certificateId: "",
    limit: "",
  });

  useEffect(() => {
    getCertis();
    getCertificateList();
  }, []);

  const columns = [
    {
      name: "Certificate",
      selector: (row) =>
        `${row.certi.certificateId} , ${row.certi.certificateTitle}`,
      sortable: true,
    },
    {
      name: "Limit",
      selector: (row) => row._doc.limit,
      sortable: true,
    },
  ];

  const getCertis = () => {
    setLoading(true);

    axios
      .get(`/all-admin-certificates`, adminConfig())
      .then((res) => {
        if (res.data.status === true) {
          // message.success("fetched certis success");
          let options = [
            {
              label: "Select Certificate",
              value: 0,
              isDisabled: true,
            },
          ];

          res.data.data.map((mapData, i) => {
            if (
              mapData.certificateId != "TVIACCESSPLUSRESTAURANT" &&
              mapData.certificateId != "SFX5NIGHT" &&
              mapData.certificateId != "SFX7NIGHT"
            ) {
              let obj = {
                label: `${mapData.certificateId} ${mapData.certificateTitle}`,
                value: mapData.certificateId,
              };
              options.push(obj);
            }
          });

          setoptionUser(options);

          setLoading(false);
        } else {
          message.error("Data Not Found");
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const getCertificateList = () => {
    setLoading(true);

    axios
      .get(`/get-certificate-limit-list`, adminConfig())
      .then((res) => {
        if (res.data.status === true) {
          // message.success("fetched certis success");
          setLimitList(res.data.data);
          setLoading(false);
        } else {
          message.error("Data Not Found");
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const handelSubmit = async (e) => {
    if (selected.length > 0 && submitData.limit > 0) {
      setLoading(true);
      let selectedData = [];
      selected.forEach((element) => {
        selectedData.push(element.value);
      });
      let data = {
        certificateId: selectedData,
        limit: submitData.limit,
      };
      await axios
        .post(`/certificate-limit-set`, data, adminConfig())
        .then((res) => {
          if (res.data.status === true) {
            message.success(res.data.message);
            getCertificateList();
            setSubmitData({
              certificateId: "",
              limit: "",
            });
            setSelected([]);
          } else {
            message.error("Update Failed!");
          }
          console.log(res.data);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        });
    } else {
      message.error("Please enter correctly!");
    }
  };

  return (
    <LoadingOverlay active={loading} spinner text="loading...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added">
                <Row>
                  <Col md={12}>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <h5>Certificate Remainder Limit</h5>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <ReactSelect
                        name="certificateId"
                        isMulti
                        options={optionUser}
                        value={selected}
                        onChange={setSelected}
                        labelledBy={""}
                        title="Select Certificate"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Control
                        type="number"
                        placeholder="Enter Limit of Certificate Code"
                        className="text_link"
                        name="limit"
                        value={submitData.limit}
                        onChange={async (e) => {
                          setSubmitData({
                            ...submitData,
                            limit: Number(e.target.value),
                          });
                        }}
                      ></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <button
                        type="button"
                        onClick={handelSubmit}
                        className="add_but submit_buttt mt-0"
                      >
                        Update
                      </button>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="plan_data">
                      <DataTable
                        columns={columns}
                        data={limitList}
                        pagination
                        striped
                        responsive
                        subHeaderAlign="right"
                        subHeaderWrap
                        paginationRowsPerPageOptions={[10, 15, 20, 40]}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
}
